import {
  type ReplacementConfig,
  type ImageReplacement,
  type Replacement,
} from '../types';

const isImage = (element: HTMLElement): element is HTMLImageElement =>
  element.tagName === 'IMG';

export const imageProcessor: ReplacementConfig<ImageReplacement> = {
  selector: 'img',
  processor: (element) => {
    if (isImage(element)) {
      return {
        type: 'image',
        img: element,
        src: element.getAttribute('src') || '',
        alt: element.getAttribute('alt') || '',
        width: element.getAttribute('width') || undefined,
        height: element.getAttribute('height') || undefined,
        style: element.getAttribute('style') || undefined,
      };
    }
    return {};
  },
  getKey: (replacement: Replacement) => {
    if (replacement.type === 'image') {
      return `image:${replacement.src}:${replacement.alt}:${replacement.width || ''}:${replacement.height || ''}:${replacement.style || ''}:${replacement.isWrappedInLink || false}`;
    }
    // This should never happen for imageProcessor, but TypeScript requires it
    return '';
  },
};
